import { createFiniteDecimalFromAnyStringNonStrict } from "@goodfill/decimal";
import Decimal from "decimal.js";

const getItem = (key: string): string | null => sessionStorage.getItem(key);

export const removeItemFromSessionStorage = (key: string) => sessionStorage.removeItem(key);

export const getSessionStorageBoolean = (key: string): boolean | undefined => {
  const value = getItem(key);
  if (value === null) {
    return undefined;
  }

  if (value === "true") {
    return true;
  }

  if (value === "false") {
    return false;
  }

  return undefined;
};

export const saveBooleanToSessionStorage = (key: string, value: boolean) =>
  sessionStorage.setItem(key, value ? "true" : "false");

export const getSessionStorageNumber = (key: string): number | undefined => {
  const value = getItem(key);
  if (value === null) {
    return undefined;
  }
  const num = Number(value);
  if (typeof num === "number" && !isNaN(num)) {
    return num;
  }

  return undefined;
};

export const saveNumberToSessionStorage = (key: string, value: number) => sessionStorage.setItem(key, String(value));

export const getSessionStorageString = (key: string): string | undefined => {
  const value = getItem(key);

  return value ?? undefined;
};

export const saveStringToSessionStorage = (key: string, value: string) => sessionStorage.setItem(key, value);

export const getSessionStorageDecimal = (key: string): Decimal | undefined => {
  const value = getItem(key);

  if (value === null) {
    return undefined;
  }

  const decimal = createFiniteDecimalFromAnyStringNonStrict(value);

  return decimal ?? undefined;
};

export const saveDecimalToSessionStorage = (key: string, value: Decimal, precision = 30) =>
  sessionStorage.setItem(key, value.toFixed(precision));

export const getSessionStorageArray = (key: string): string[] | undefined => {
  const value = getItem(key);

  if (value === null) {
    return undefined;
  }

  return JSON.parse(value) as string[];
};

export const saveArrayToSessionStorage = (key: string, value: string[]) =>
  sessionStorage.setItem(key, JSON.stringify(value));
